module.exports = __webpack_public_path__ + "img/empty-chart.becedd81.svg";